/* eslint-disable react/require-default-props */
import Loader from 'components/atoms/loader';
import React, { useRef } from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import TotalEntriesLabel from 'components/atoms/total_entries_label';
import Pagination from 'components/atoms/pagination';
import logoConlicitacao from 'assets/images/logo-conlicita-verde.svg';
import { FollowupState } from 'store/modules/followup_store/types';
import FollowupItem from 'components/molecules/followup_item';

interface SharedFollowupListProps {
  currentPage: number;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
}

const SharedFollowupList = (props: SharedFollowupListProps) => {
  const { currentPage, setCurrentPage } = props;
  const { followups, request } = useSelector<ApplicationState, FollowupState>(
    (state) => state.session.followups,
  );

  const componentRef = useRef() as React.MutableRefObject<HTMLInputElement>;

  const updateCurrentPage = (currentPage = 1) => {
    setCurrentPage(currentPage);
  };

  return (
    <div className="page-container w-100">
      <div className="container p-4">
        {request?.loading && (
          <div className="d-flex align-items-center justify-content-center loading-container">
            <Loader />
          </div>
        )}
        {request?.loaded && followups?.followup_list?.length > 0 && (
          <div className="row">
            <div className="col-12 p-0">
              <h4 className="font-weight-bold">Compartilhamento de Acompanhamentos</h4>
            </div>
            <div className="col-12 d-flex justify-content-end text-secondary p-0">
              <TotalEntriesLabel itemLabel="licitações" totalEntries={followups.total_entries} />
            </div>

            <div ref={componentRef} className="row mx-1 mt-5">
              <div className="col-12">
                {request?.loaded &&
                  followups?.followup_list?.map((followup, index) => (
                    <FollowupItem
                      key={followup.id}
                      followup={followup}
                      followupIndex={index + (currentPage - 1) * 20}
                      isChecked={false}
                      toggleSelected={() => {}}
                      source="followupOnlineSearch"
                    />
                  ))}
              </div>
            </div>
          </div>
        )}
        {request?.loaded && followups.total_entries !== 0 && (
          <div className="row d-print-none">
            <div className="col-12 mx-auto mb-5 pb-5 p-md-0">
              <Pagination
                postsPerPage={20}
                totalPosts={followups.total_entries}
                paginate={updateCurrentPage}
                currentPage={currentPage || 1}
                firstAndLastPage
              />
            </div>
          </div>
        )}
        <div className="row">
          <div className="col-md-12 p-0">
            <h6 className="font-weight-bold">POLÍTICA DE USO E RESPONSABILIDADE DE CONTEÚDO</h6>
            <p>1) As informações aqui apresentadas não substituem as publicações oficiais.</p>
            <p>
              2) Os serviços de informação prestados pelo ConLicitação se constituem em obrigações
              de meios, independendo do resultado nos certames.
            </p>
            <p>
              3) A exclusividade do uso é restrita à pessoa jurídica identificada no cadastro de
              clientes do ConLicitação, a quem está direcionado o presente, sendo portanto vedado
              aos usuários distribuir, transmitir, exibir, reproduzir ou transferir quaisquer
              informações aqui contidas, exceto dentro do seu meio corporativo.
            </p>
            <p>
              <a href="mailto:apoio@conlicitacao.com.br">apoio@conlicitacao.com.br</a>
            </p>
            <p className="d-flex align-items-center">
              Todos os direitos reservados ©{' '}
              <img className="ml-1" src={logoConlicitacao} height="18px" alt="Logo Conlicitação" />
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SharedFollowupList;
